import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";

export default class Moment extends Component {
  render() {
    const { date, format } = this.props;

    const formattedDate = moment(date).format("Do MMM YYYY, h:mm a");

    return <span {...this.props}>{formattedDate}</span>;
  }
}

Moment.propTypes = {
  children: PropTypes.node,
};
